import { Checkbox, FormControlLabel } from '@mui/material';
import styled from 'styled-components';
import theme from 'styles/theme';
import React, { forwardRef, ReactElement } from 'react';
import { CheckboxProps } from '@mui/material/Checkbox/Checkbox';

export const StyledCheckBox = styled(Checkbox)`
  &.mui-checked: {
    color: ${theme.palette.primary.main};
  }
`;

interface BravoCheckBoxProps extends CheckboxProps {
  label: ReactElement;
}

// eslint-disable-next-line react/display-name
export const BravoCheckBox = forwardRef((props: BravoCheckBoxProps, ref: React.Ref<HTMLLabelElement>) => {
  const { label, value } = props;
  return (
    <FormControlLabel
      label={label}
      control={<StyledCheckBox {...props} checked={(value as boolean) || false}></StyledCheckBox>}
      ref={ref}
    />
  );
});
